<template>
  <tk-dialog-layout-form
    ref="dialogForm"
    v-loading="loading"
    :form-data.sync="formData"
    :formSpan="24"
    label-width="110px"
    :item="formItem"
    :operate-type="operateType"
    :rules="formRules"
    width="600px"
    @submit="submit"
  >
  </tk-dialog-layout-form>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "DialogApproval",
  props: {},
  data() {
    return {
      loading: false,
      operateType: "edit",
      formData: {
        id: "",
        approvalState: "",
        reason: "",
      },
      formItem: {
        title: "审核找车价格",
        content: [
          {
            title: {
              key: "base",
              label: "基础信息",
            },
            formItems: [
              {
                label: "审核结果",
                prop: "approvalState",
                type: "radio",
                options: [
                  { value: 1, label: "通过" },
                  { value: 2, label: "驳回" },
                ],
              },
              {
                label: "审核说明",
                prop: "reason",
                type: "input",
                nativeType: "textarea",
                autosize: { minRows: 5 },
                maxlength: 100,
                "show-word-limit": true,
              },
            ],
          },
        ],
      },
      formRules: {
        approvalState: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
        reason: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {},
  mounted() {},
  methods: {
    ...mapActions(["orderApprovalApprovalOrder"]),
    openDialog({ row }) {
      this.initData();
      this.formData.id = row.id;
      this.$refs.dialogForm.show();
    },
    initData() {
      this.formData = {
        id: "",
        approvalState: "",
        reason: "",
      };
    },
    closeDialog() {
      this.$refs.dialogForm.hide();
    },
    submit() {
      this.loading = true;
      this.orderApprovalApprovalOrder(this.formData)
        .then(() => {
          this.$message.success("审核成功！");
          this.$parent.searchList();
          this.closeDialog();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
